/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Adjustment_Link_Generation_FailedInputs */

const en_shipping_adjustment_link_generation_failed = /** @type {(inputs: Shipping_Adjustment_Link_Generation_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping adjustment created, but payment link generation failed`)
};

const es_shipping_adjustment_link_generation_failed = /** @type {(inputs: Shipping_Adjustment_Link_Generation_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El ajuste de envio se creo, pero fallo la generacion del link de pago`)
};

/**
* | output |
* | --- |
* | "Shipping adjustment created, but payment link generation failed" |
*
* @param {Shipping_Adjustment_Link_Generation_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const shipping_adjustment_link_generation_failed = /** @type {((inputs?: Shipping_Adjustment_Link_Generation_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Adjustment_Link_Generation_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_adjustment_link_generation_failed(inputs)
	return es_shipping_adjustment_link_generation_failed(inputs)
});